export default __webpack_public_path__ + "02a6ac7e80f347ee12a105b6c66b69f8.png";